'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const useEventListener = require('../../utils/hooks/useEventListener/useEventListener.js');
require('../../utils/hooks/useMedia/useMedia.js');
require('../../utils/hooks/useScript/useScript.js');
const scrollLock = require('../ScrollLock/scrollLock.js');
const portal = require('../Portal/portal.js');
const scrollbarWidthOffset = require('../ScrollbarWidthOffset/scrollbarWidthOffset.js');
const backdrop = require('./Backdrop/backdrop.js');
const modalContent = require('./ModalContent/modalContent.js');
const modal_style = require('./modal.style.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DEFAULT_DATA_ATTR = {
  'data-testid': 'modal'
};
var Modal = function Modal(_ref) {
  var ariaLabel = _ref.ariaLabel,
    _ref$BackdropComponen = _ref.BackdropComponent,
    BackdropComponent = _ref$BackdropComponen === void 0 ? backdrop : _ref$BackdropComponen,
    _ref$backdropEventTyp = _ref.backdropEventType,
    backdropEventType = _ref$backdropEventTyp === void 0 ? 'onClick' : _ref$backdropEventTyp,
    backdropProps = _ref.backdropProps,
    children = _ref.children,
    className = _ref.className,
    CloseButtonComponent = _ref.CloseButtonComponent,
    closeButtonProps = _ref.closeButtonProps,
    _ref$ContentComponent = _ref.ContentComponent,
    ContentComponent = _ref$ContentComponent === void 0 ? modalContent : _ref$ContentComponent,
    contentProps = _ref.contentProps,
    _ref$dataAttr = _ref.dataAttr,
    dataAttr = _ref$dataAttr === void 0 ? {} : _ref$dataAttr,
    _ref$disableBackdropC = _ref.disableBackdropClick,
    disableBackdropClick = _ref$disableBackdropC === void 0 ? false : _ref$disableBackdropC,
    _ref$disablePortal = _ref.disablePortal,
    disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
    _ref$disableScrollbar = _ref.disableScrollbarWidthOffset,
    disableScrollbarWidthOffset = _ref$disableScrollbar === void 0 ? false : _ref$disableScrollbar,
    _ref$disableScrollLoc = _ref.disableScrollLock,
    disableScrollLock = _ref$disableScrollLoc === void 0 ? false : _ref$disableScrollLoc,
    height = _ref.height,
    _ref$hideBackdrop = _ref.hideBackdrop,
    hideBackdrop = _ref$hideBackdrop === void 0 ? false : _ref$hideBackdrop,
    _ref$hideCloseButton = _ref.hideCloseButton,
    hideCloseButton = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
    _ref$isCentered = _ref.isCentered,
    isCentered = _ref$isCentered === void 0 ? false : _ref$isCentered,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    onClose = _ref.onClose,
    _ref$PortalComponent = _ref.PortalComponent,
    PortalComponent = _ref$PortalComponent === void 0 ? portal : _ref$PortalComponent,
    portalProps = _ref.portalProps,
    position = _ref.position,
    scrollType = _ref.scrollType,
    width = _ref.width;
  var ModalContentRef = React.useRef(null);
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    previousActiveElement = _useState2[0],
    setPreviousActiveElement = _useState2[1];
  React.useEffect(function () {
    if (isOpen) {
      if (ModalContentRef.current) {
        if (!previousActiveElement) {
          setPreviousActiveElement(document.activeElement);
        }
        ModalContentRef.current.focus({
          preventScroll: true
        });
      }
    } else {
      if (previousActiveElement) {
        previousActiveElement.focus({
          preventScroll: true
        });
        setPreviousActiveElement(null);
      }
    }
  }, [isOpen, previousActiveElement]);
  var onModalClose = React.useCallback(function (event, reason) {
    return onClose({
      event: event,
      reason: reason
    });
  }, [onClose]);
  var onBackdropClick = React.useCallback(function (event) {
    if (!disableBackdropClick) {
      onModalClose(event, 'backdropClick');
    }
  }, [disableBackdropClick, onModalClose]);
  var onCloseButtonClick = React.useCallback(function (event) {
    return onModalClose(event, 'closeButtonClick');
  }, [onModalClose]);
  var onKeyDown = React.useCallback(function (event) {
    var key = event.key;
    /**
     * `Esc` is IE/Edge specific
     * Reference: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key#example
    */
    if (isOpen && (key === 'Escape' || key === 'Esc')) {
      onModalClose(event, 'escapeKeyPress');
    }
  }, [isOpen, onModalClose]);
  useEventListener('keydown', onKeyDown);
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  var combinedBackdropProps = _objectSpread(_objectSpread({}, backdropProps), {}, _defineProperty({}, backdropEventType, onBackdropClick));
  return /*#__PURE__*/React__default.createElement(PortalComponent, _extends({
    disablePortal: disablePortal
  }, portalProps), isOpen && /*#__PURE__*/React__default.createElement(modal_style.ModalContainer, _extends({
    "aria-label": ariaLabel,
    "aria-modal": true,
    className: className,
    isCentered: isCentered,
    role: "dialog",
    scrollType: scrollType
  }, combinedDataAttr), !disableScrollbarWidthOffset && /*#__PURE__*/React__default.createElement(scrollbarWidthOffset, null), !disableScrollLock && /*#__PURE__*/React__default.createElement(scrollLock.default, null), !hideBackdrop && /*#__PURE__*/React__default.createElement(BackdropComponent, combinedBackdropProps), /*#__PURE__*/React__default.createElement(ContentComponent, _extends({
    CloseButtonComponent: CloseButtonComponent,
    closeButtonProps: _objectSpread(_objectSpread({}, closeButtonProps), {}, {
      handlers: {
        onClick: onCloseButtonClick
      }
    }),
    contentRef: ModalContentRef,
    height: height,
    hideCloseButton: hideCloseButton,
    isCentered: isCentered,
    position: position,
    scrollType: scrollType,
    width: width
  }, contentProps), children)));
};
const Modal$1 = /*#__PURE__*/React__default.memo(Modal);

module.exports = Modal$1;
